import { Users, Home, LineChart, Heart } from "lucide-react";

const ITEMS = [
  { icon: Users, label: "Trusted by Owners & Investors" },
  { icon: Home, label: "Focused on Strategy, Not Daily Ops" },
  { icon: LineChart, label: "Data-Driven Decisions, Real Results" },
  { icon: Heart, label: "Less Overwhelm. More Freedom." },
];

export default function TrustBar() {
  return (
    <section data-testid="home-trustbar" className="bg-navy text-ivory">
      <div className="container-editorial py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-ivory/15">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`trust-item-${i}`}
                className="flex items-start gap-4 md:flex-col md:items-start md:px-8 py-4 md:py-0"
              >
                <Icon className="w-6 h-6 text-gold shrink-0 mt-0.5 md:mb-5" strokeWidth={1.4} />
                <p className="font-ui uppercase tracking-[0.14em] text-[13px] md:text-[14px] leading-[1.5] font-medium text-ivory">
                  {it.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
